import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardContentDataApi } from '../../../api/dashboard/adminGetDashboardContentDataApi';
import { AdminDashboardContentStaticsResponse, AdminDashboardDataFilter } from '../../../graphql/API';

export const useAdminGetDashboardContentDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardContentStaticsResponse, Error> => {
  const adminGetDashboardContentData = useQuery({
    queryKey: ['admin-get-dashboard-content-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardContentDataApi({ ...filter });
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate || !!filter.priorToDate || !!filter.toDate,
  });
  return { ...adminGetDashboardContentData };
};
